<div class="kakaotalk-template">
  <div class="selectable" *ngIf="true">
    <ng-content></ng-content>
  </div>
  <div class="content">
    <div class="template-name">{{ template.name }}</div>
    <div class="template-text">
      {{ template.textWithReplacedPlaceholders }}
    </div>
    <div>
      <button
        mat-stroked-button
        *ngFor="let button of template.buttons; index as j"
        [attr.data-testid]="'template-button-' + j"
        class="template-button">
        <span>{{ button?.text }}</span>
      </button>
    </div>
  </div>
</div>
